import axios from 'utils/axios';

export const getPatientAppointments = (patientId: string, page: number, pageSize: number) =>
  axios.get(`/api/v1/profile/${patientId}/appointments`, { params: { page, pageSize } });
